import MomentUtils from '@date-io/moment'
import moment from 'moment'
import 'moment/locale/pt-br'
import React, { useContext, useEffect } from 'react'

import DateFnsUtils from '@date-io/date-fns'
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
import uuid from 'uuid/v4'

import { FaPlus, FaTrashAlt } from 'react-icons/fa'
import Context from '../../context'
import { ParserListDate } from '../../helpers/EventValuesHelper'

moment.locale('pt-br')

function EventDateList() {
  const { formObject, setFormObject, listDate, setListDate } = useContext(Context)

  const handleStartDayChange = id => date => {
    const newArr = listDate.map(item => {
      if (item.id === id) {
        return { ...item, startDate: date }
      }
      return { ...item }
    })

    setListDate([...newArr])
  }

  const handleEndDayChange = id => date => {
    const newArr = listDate.map(item => {
      if (item.id === id) {
        return { ...item, endDate: date }
      }
      return { ...item }
    })

    setListDate([...newArr])
  }

  const handleTimeChange = id => hour => {
    const newArr = listDate.map(item => {
      if (item.id === id) {
        return { ...item, time: hour }
      }
      return { ...item }
    })

    setListDate([...newArr])
  }

  const handleAddItem = () => {
    const newArr = [...listDate]
    const newObj = {
      id: uuid(),
      startDate: newArr[0].startDate,
      endDate: newArr[0].endDate,
      time: newArr[0].time
    }
    newArr.push(newObj)
    setListDate([...newArr])
  }

  const handleDeleteItem = id => {
    const newArr = listDate.filter(item => {
      return item.id !== id
    })

    setListDate([...newArr])
  }

  useEffect(() => {
    setFormObject({
      ...formObject,
      eventsProgramming: ParserListDate(listDate)
    })
  }, [listDate])

  return (
    <>
      {listDate.map(date => (
        <div key={date.id} className="col-12 d-inline-flex justify-content-between">
          <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
            <KeyboardDatePicker
              margin="normal"
              id={`startDate-${date.id}`}
              label="Do dia..."
              format="DD/MM/YYYY"
              value={date.startDate}
              onChange={handleStartDayChange(date.id)}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
            <KeyboardDatePicker
              margin="normal"
              id={`endDate-${date.id}`}
              label="Até dia..."
              format="DD/MM/YYYY"
              minDate={date.startDate}
              minDateMessage="A Data final não pode ser inferior ao início."
              value={date.endDate}
              onChange={handleEndDayChange(date.id)}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardTimePicker
              ampm={false}
              margin="normal"
              id="time"
              label="Hora"
              value={date.time}
              onChange={handleTimeChange(date.id)}
              KeyboardButtonProps={{
                'aria-label': 'Alterar Hora'
              }}
            />
          </MuiPickersUtilsProvider>
          <div className="d-inline-flex justify-content-around align-content-center">
            <button
              onClick={handleAddItem}
              type="button"
              className="btn clube-button clube-btn clube-blue"
            >
              <FaPlus />
            </button>
            <button
              disabled={listDate.length === 1}
              onClick={() => handleDeleteItem(date.id)}
              type="button"
              className="btn clube-button clube-btn bg-danger text-white"
            >
              <FaTrashAlt />
            </button>
          </div>
        </div>
      ))}
    </>
  )
}

export default EventDateList
